import { Collapse, Grid, IconButton } from '@material-ui/core'
import {
  ChevronLeft,
  ChevronRight,
  ExpandLess,
  ExpandMore,
  FiberManualRecord,
  FolderOpenOutlined,
  HttpOutlined,
  InfoOutlined,
  ListAltOutlined,
  LockOutlined,
  PaymentOutlined,
  ReceiptOutlined,
  ShoppingBasketOutlined,
} from '@material-ui/icons'
import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import sidebarSections from '../sidebar.json'

const Sidebar = ({ collapsed = false, onToggleCollapsed = () => {} }) => {

  const history = useHistory()
  const location = useLocation()

  const [selectedLink, setSelectedLink] = useState('')
  const [expandedSections, setExpandedSections] = useState({})

  const getSectionId = (section) => section.page || section.label || ''

  useEffect(() => {
    const link = `${location.pathname.substring(1)}${location.hash}`
    setSelectedLink(link)

    const activeSection = sidebarSections.find((section) => {
      if (section.subsections) {
        return section.subsections.some((subsection) => `${subsection.page || ''}${subsection.path || ''}` === link)
      }
      return `${section.page || ''}${section.path || ''}` === link || (!link && section.default)
    })

    if (activeSection) {
      const sectionId = getSectionId(activeSection)
      setExpandedSections((prev) => ({ ...prev, [sectionId]: true }))
    }
  }, [location])

  const toggleSection = (sectionId) => (e) => {
    e.stopPropagation()
    setExpandedSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }))
  }

  const handleClick = (section) => (e) =>  {
    if (section.subsections) {
      const sectionId = getSectionId(section)
      setExpandedSections((prev) => ({
        ...prev,
        [sectionId]: !prev[sectionId]
      }))
      if (!section.page) {
        return
      }
    }

    if (!section.page) {
      return
    }
    history.push(`/${section.page}${section.path || ''}`)
  }

  const isSelected = (section) => {
    if (!selectedLink && section.default) {
      return true
    }

    if (selectedLink === `${section.page || ''}${section.path || ''}`) {
      return true
    }

    if (section.subsections) {
      return section.subsections.some((subsection) => `${subsection.page || ''}${subsection.path || ''}` === selectedLink)
    }

    return false
  }

  const getSectionIcon = (section) => {
    const key = `${section.label || ''} ${section.page || ''}`.toLowerCase()

    if (key.includes('intro')) return <InfoOutlined fontSize="small" />
    if (key.includes('auth')) return <LockOutlined fontSize="small" />
    if (key.includes('product')) return <ShoppingBasketOutlined fontSize="small" />
    if (key.includes('purchase')) return <PaymentOutlined fontSize="small" />
    if (key.includes('webhook')) return <HttpOutlined fontSize="small" />
    if (key.includes('invoice')) return <ReceiptOutlined fontSize="small" />
    if (section.subsections) return <FolderOpenOutlined fontSize="small" />
    return <ListAltOutlined fontSize="small" />
  }

  const subsectionIcon = <FiberManualRecord fontSize="small" />

  // console.log(sidebarSections)

  return (
    <Grid container direction="column" className={`sidebar-container ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-collapse-toggle" onClick={onToggleCollapsed}>
        <IconButton size="small">
          { collapsed ? <ChevronRight fontSize="small" /> : <ChevronLeft fontSize="small" /> }
        </IconButton>
      </div>
      { sidebarSections.map((section, si) => {
        const sectionSelected = isSelected(section)
        const sectionId = getSectionId(section)
        const isExpanded = Boolean(expandedSections[sectionId])
        const sectionIcon = section.type === 'header' ? null : getSectionIcon(section)

        if (collapsed && section.type === 'header') {
          return <div key={`sidebar_block_${si}`} className="sidebar-header-separator" />
        }

        return (
          <div key={`sidebar_block_${si}`}>
            <Grid item onClick={handleClick(section)} className={`sidebar row ${section.type} ${sectionSelected ? 'selected' : ''}`}>
              { sectionIcon && <span className="sidebar-icon">{ sectionIcon }</span> }
              <span className="sidebar-label">{ section.label }</span>
              { section.subsections &&
                <IconButton
                  size="small"
                  className="sidebar-toggle"
                  onClick={toggleSection(sectionId)}
                  aria-label={`${isExpanded ? 'Collapse' : 'Expand'} ${section.label}`}
                >
                  { isExpanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" /> }
                </IconButton>
              }
            </Grid>
            <Collapse in={!collapsed && isExpanded && Boolean(section.subsections)} timeout="auto" unmountOnExit>
              <div className="subsections-wrapper"> 
              { section.subsections && section.subsections.map((subsection, ssi) => {
                const subsectionSelected = isSelected(subsection)
                return (
                  <div
                    key={`sidebar_row_${si}_subsection_${ssi}`}
                    onClick={handleClick(subsection)}
                    className={`sidebar subsection row ${subsection.type} ${subsectionSelected ? 'selected' : ''}`}
                  >
                    <span className="sidebar-icon subsection-icon">{ subsectionIcon }</span>
                    { subsection.label }
                  </div>
                )
              })}
              </div>
            </Collapse>
          </div>
        )
      })}
    </Grid>
  )
}

export default Sidebar
